export default { 
  name: 'sets',
  path: '/sets'
}